// import React, { useCallback, useEffect, useState, useRef } from "react";
// import ProcessLayout from "../Common/ProcessLayout";
// import AudioFilesToDiarize from "./DiarizationComponents/AudioFilesToDiarize";
// import DiarizationProcess from "./DiarizationComponents/DiarizationProcess";
// import DiarizationProcessLogs from "./DiarizationComponents/DiarizationProcessLogs";
// import DiarizationFilewiseStatusLogs from "./DiarizationComponents/DiarizationFilewiseStatusLogs";
// import { TRANSCRIPT_URL, PROJECT_URL } from "../../imports";
// import axios from "axios";
// import Popup from "../Common/Popup";
// import { handleApiError } from "../Common/APIUtils";

// function Diarization() {
//     const [startProcess, setStartProcess] = useState(false);
//     const [fetchedFilesData, setFetchedFilesData] = useState([]);
//     const [inProgressFiles, setInProgressFiles] = useState([]);
//     const [logsData, setLogsData] = useState([]);
//     const [processedFiles, setProcessedFiles] = useState([]);
//     const [unprocessedFiles, setUnProcessedFiles] = useState([]);
//     const [Loader, setLoader] = useState(true);
    
//     const [startIndex, setStartIndex] = useState(undefined);
//     const [endIndex, setEndIndex] = useState(undefined);
//     const [rowSelection, setRowSelection] = useState({});
    
//     const [fslstartIndex, setfslStartIndex] = useState(undefined);
//     const [fslendIndex, setfslEndIndex] = useState(undefined);
//     const [fslrowSelection, setfslRowSelection] = useState({});
//     const [serverStatus, setServerStatus] = useState(false);
//     const [serviceUrl, setServiceUrl] = useState("");
//     const [serverLoadState, setServerLoadState] = useState(true);
//     const [activeTab, setActiveTab] = useState(0);
    
//     // const [diarizationSettings, setDiarizationSettings] = useState({
//     //     api_key: "",
//     //     process_as_wav: 0,
//     //     pii_masking: 0,
//     //     pii_entities_list: []
//     // });
    
//     let [isOpenPopup, setIsOpenPopup] = useState(false);
//     let [msg, setMsg] = useState(false);
//     let [isSuccess, setIsSuccess] = useState(false);

//     const pollingIntervalRef = useRef(null);

//     function closePopup() {
//         setIsOpenPopup(false);
//     }

//     const openPopup = useCallback(() => {
//         setIsOpenPopup(true);
//     }, []);

//     const stopPolling = useCallback(() => {
//         if (pollingIntervalRef.current) {
//             clearInterval(pollingIntervalRef.current);
//             pollingIntervalRef.current = null;
//         }
//     }, []);

//     // const fetchInProgressDiarizations = useCallback(async () => {
//     //     try {
//     //         const projectCode = sessionStorage.getItem("projectCode");
//     //         if (!projectCode) return;

//     //         const response = await axios.get(
//     //             `${TRANSCRIPT_URL}/diarization/in-progress/${projectCode}`,
//     //             {
//     //                 headers: {
//     //                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//     //                 },
//     //             }
//     //         );

//     //         if (response.data && response.data.data) {
//     //             // const activeFiles = response.data.data.filter(file => 
//     //             //     file.status === "Inprogress" || 
//     //             //     file.status === "submitted" || 
//     //             //     file.status === "Processing"
//     //             // );
//     //             const activeFiles = response.data.data;
//     //             console.log("📊 In-progress files:", activeFiles.map(f => ({ name: f.name, status: f.status })));
                
//     //             setInProgressFiles(activeFiles);
                
//     //             if (activeFiles.length === 0) {
//     //                 stopPolling();
//     //             }
//     //         }
//     //     } catch (error) {
//     //         console.log("No in-progress diarizations:", error.message);
//     //         setInProgressFiles([]);
//     //     }
//     // }, [stopPolling]);

//     const fetchInProgressDiarizations = useCallback(async () => {
//         try {
//             const projectCode = sessionStorage.getItem("projectCode");
//             if (!projectCode) return;

//             const response = await axios.get(
//                 `${TRANSCRIPT_URL}/diarization/in-progress/${projectCode}`,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//                     },
//                 }
//             );

//             if (response.data && response.data.data) {
//                 setInProgressFiles(response.data.data);
                
//                 if (response.data.data.length === 0) {
//                     stopPolling();
//                 }
//             }
//         } catch (error) {
//             console.log("No in-progress diarizations:", error.message);
//             setInProgressFiles([]);
//         }
//     }, [stopPolling]);

//     const fetchAllFiles = useCallback(async (batch_no = null) => {
//         try {
//             setLoader(true);
//             const projectCode = sessionStorage.getItem("projectCode");
            
//             const response = await axios.get(
//                 `${TRANSCRIPT_URL}/diarization/getfilelist/${projectCode}`,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//                     },
//                     params: {
//                         batch: batch_no || sessionStorage.getItem("batch") || null,
//                     },
//                 }
//             );

//             const statusResponse = await axios.get(
//                 `${TRANSCRIPT_URL}/diarization/filewisestatusrpt/${projectCode}`,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//                     },
//                 }
//             );

//             if (response.data && response.data.data) {
//                 const allFiles = response.data.data;
//                 const completedFileCodes = statusResponse.data.data
//                     .filter(f => f.status === "Success" || f.status === "success")
//                     .map(f => f.file_code);

//                 // const availableFiles = allFiles.filter(file => 
//                 //     file.status !== "Inprogress" && 
//                 //     file.status !== "submitted" &&
//                 //     file.status !== "Processing" &&
//                 //     file.status !== "Success" &&
//                 //     file.status !== "success" &&
//                 //     !completedFileCodes.includes(file.file_code)
//                 // );
//                  // Filter out text/json/csv files and processing/completed files
//                 const availableFiles = allFiles.filter(file => {
//                     const fileName = file.file_name || file.name || "";
//                     const isTextFile = fileName.endsWith('.txt') || fileName.endsWith('.json') || fileName.endsWith('.csv');
//                     const isProcessing = file.status === "Inprogress" || file.status === "submitted" || file.status === "Processing" || file.status === "Success" || file.status === "success";
//                     const isCompleted = completedFileCodes.includes(file.file_code);
                    
//                     return !isTextFile && !isProcessing && !isCompleted;
//                 });
//                 setFetchedFilesData(availableFiles);
//             }
//         } catch (error) {
//             const errorMessage = handleApiError(error);
//             setMsg(errorMessage);
//             setIsSuccess(false);
//             openPopup();
//         } finally {
//             setTimeout(() => setLoader(false), 100);
//         }
//     }, [openPopup]);

//     const startPolling = useCallback(() => {
//         if (pollingIntervalRef.current) return;

//         pollingIntervalRef.current = setInterval(() => {
//             fetchInProgressDiarizations();
//         }, 5000);
//     }, [fetchInProgressDiarizations]);

//     useEffect(() => {
//         const initializeData = async () => {
//             await Promise.all([
//                 fetchAllFiles(),
//                 fetchInProgressDiarizations(),
//             ]);
//             try {
//                 const response = await axios.get(
//                     `${TRANSCRIPT_URL}/diarization/instancemonitor`,
//                     {
//                         headers: {
//                             Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//                         },
//                         params: { server_instance: "GPU" },
//                     }
//                 );
//                 if (response.data) {
//                     setServerStatus(response.data.data[0].serverStatus);
//                     setServiceUrl(response.data.data[0].service_url);
//                 }
//             } catch (error) {
//                 setServerStatus(false);
//                 setServiceUrl("");
//             } finally {
//                 setServerLoadState(false);
//             }
//         };

//         initializeData();

//         const checkAndStartPolling = async () => {
//             const projectCode = sessionStorage.getItem("projectCode");
//             if (!projectCode) return;

//             try {
//                 const response = await axios.get(
//                     `${TRANSCRIPT_URL}/diarization/in-progress/${projectCode}`,
//                     {
//                         headers: {
//                             Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//                         },
//                     }
//                 );

//                 if (response.data && response.data.data && response.data.data.length > 0) {
//                     startPolling();
//                 }
//             } catch (error) {
//                 console.log("No initial polling needed");
//             }
//         };

//         checkAndStartPolling();

//         return () => {
//             stopPolling();
//         };
//     }, [fetchAllFiles, fetchInProgressDiarizations, startPolling, stopPolling]);


//     // useEffect(() => {
//     //     if (startProcess) {
//     //         if (inProgressFiles.length === 0 && processedFiles.length > 0) {
//     //             setStartProcess(false);
//     //             setActiveTab(3);
//     //             stopPolling();
//     //         } else if (inProgressFiles.length > 0) {
//     //             const allCompleted = inProgressFiles.every(file => 
//     //                 file.status === 'success' || file.status === 'error'
//     //             );
                
//     //             if (allCompleted) {
//     //                 setStartProcess(false);
//     //                 setActiveTab(3);
//     //                 stopPolling();
//     //             }
//     //         }
//     //     }
//     // }, [inProgressFiles, startProcess, processedFiles.length, stopPolling]);

//     // const handleStartProcess = async (data) => {
//     //     setStartProcess(true);

//     //     const currentLogs = [];
//     //     const updatedProcessedFiles = [];
//     //     const updatedUnprocessedFiles = [];

//     //     const formattedStartDateTime = () => {
//     //         const date = new Date();
//     //         const formattedDateString = date
//     //             .toLocaleString("en-US", {
//     //                 day: "2-digit",
//     //                 month: "2-digit",
//     //                 year: "numeric",
//     //                 hour: "2-digit",
//     //                 minute: "2-digit",
//     //                 second: "2-digit",
//     //                 hour12: false,
//     //             })
//     //             .replace(/\//g, "/")
//     //             .replace(",", " ");
//     //         const [month, day, yearAndTime] = formattedDateString.split("/");
//     //         return `${day}-${month}-${yearAndTime}`;
//     //     };

//     //     for (let i = 0; i < data.length; i++) {
//     //         let startdt = formattedStartDateTime();
//     //         let file = data[i];
            
//     //         try {
//     //             if (!file.file_code) {
//     //                 throw new Error("File code is missing");
//     //             }

//     //             // const payload = {
//     //             //     project_code: sessionStorage.getItem("projectCode"),
//     //             //     file_code: file.file_code,
//     //             //     api_key: diarizationSettings.api_key,
//     //             //     process_as_wav: diarizationSettings.process_as_wav,
//     //             //     pii_masking: diarizationSettings.pii_masking,
//     //             //     ...(diarizationSettings.pii_entities_list.length > 0 && {
//     //             //         pii_entities_list: diarizationSettings.pii_entities_list
//     //             //     })
//     //             // const payload = {
//     //             //     project_code: sessionStorage.getItem("projectCode"),
//     //             //     file_code: file.file_code,
//     //             //     api_key: diarizationSettings.api_key,
//     //             //     process_as_wav: diarizationSettings.process_as_wav,
//     //             //     enable_fixes: diarizationSettings.enable_fixes,
//     //             //     pii_masking: diarizationSettings.pii_masking,
//     //             //     ...(diarizationSettings.pii_entities_list.length > 0 && {
//     //             //         pii_entities_list: diarizationSettings.pii_entities_list
//     //             //     })
//     //             // };
//     //             const payload = {
//     //                 project_code: sessionStorage.getItem("projectCode"),
//     //                 file_code: file.file_code,
//     //                 service: "diarization",
//     //                 model_provider: modelProvider,
//     //                 api_key: apiKey,

//     //                 // ✅ apply ACTIVE params from Params.js
//     //                 ...defaultDiarizationParams,
//     //                 ...activeDiarizationParams,

//     //                 ...(modelProvider === "azure" && {
//     //                     azure_key: params.azure_key,
//     //                     azure_endpoint: params.azure_endpoint
//     //                 })
//     //             };
//     //             console.log("Sending payload:", payload);

//     //             const response = await axios.post(
//     //                 `${TRANSCRIPT_URL}/diarization/`,
//     //                 payload,
//     //                 {
//     //                     headers: {
//     //                         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//     //                         "Content-Type": "application/json"
//     //                     },
//     //                 }
//     //             );

//     //             if (response.data.status === "diarization_started" || response.data.status === "transcription_started") {
//     //                 const submittedFile = {
//     //                     ...file,
//     //                     file_code: file.file_code,
//     //                     status: "submitted",
//     //                     response: {
//     //                         message: response.data.message,
//     //                         submitted_at: new Date().toISOString()
//     //                     },
//     //                     start_date_time: startdt,
//     //                     last_modified: "",
//     //                     diarization_model: modelProvider   // "azure" | "openai"

//     //                 };
                    
//     //                 currentLogs.push({
//     //                     creation_date: new Date(),
//     //                     filename: file.name,
//     //                     status: "submitted",
//     //                     message: response.data.message
//     //                 });
                    
//     //                 updatedProcessedFiles.push(submittedFile);
//     //                 setInProgressFiles(prev => [...prev, submittedFile]);
//     //             } else {
//     //                 console.error('Unexpected response status:', response.data.status);
//     //                 const errordate = new Date();
//     //                 currentLogs.push({
//     //                     creation_date: errordate,
//     //                     filename: file.name,
//     //                     status: "error"
//     //                 });
//     //                 updatedUnprocessedFiles.push(file);
//     //             }
//     //         } catch (error) {
//     //             console.error('Diarization Error:', error);
                
//     //             const errordate = new Date();
//     //             let errorMessage = error.response?.data?.detail || 
//     //                             error.response?.data?.message || 
//     //                             error.message ||
//     //                             "An error occurred during diarization";
                
//     //             currentLogs.push({
//     //                 filename: file.name,
//     //                 creation_date: errordate,
//     //                 error: errorMessage
//     //             });
                
//     //             setMsg(errorMessage);
//     //             setIsSuccess(false);
//     //             if (data.length === 1) {
//     //                 openPopup();
//     //             }
                
//     //             updatedUnprocessedFiles.push(file);
//     //         }
//     //     }

//     //     setLogsData(currentLogs);
//     //     setProcessedFiles(updatedProcessedFiles);
//     //     setUnProcessedFiles(updatedUnprocessedFiles);
//     //     setStartProcess(false);
        
//     //     await fetchAllFiles();
        
//     //     if (updatedProcessedFiles.length > 0) {
//     //         startPolling();
//     //     }
//     // };

//     useEffect(() => {
//         if (startProcess) {
//             if (inProgressFiles.length === 0 && processedFiles.length > 0) {
//                 console.log("✅ All files completed (empty list)");
//                 setStartProcess(false);
//                 setActiveTab(3);
//                 stopPolling();
//             } else if (inProgressFiles.length > 0) {
//                 const allCompleted = inProgressFiles.every(file => 
//                     file.status === 'Success' || 
//                     file.status === 'success' || 
//                     file.status === 'error' ||
//                     file.status === 'Error'
//                 );
                
//                 console.log("📊 Completion check:", { 
//                     total: inProgressFiles.length, 
//                     allCompleted,
//                     statuses: inProgressFiles.map(f => f.status)
//                 });
                
//                 if (allCompleted) {
//                     console.log("✅ All files completed (success/error)");
//                     setStartProcess(false);
//                     setActiveTab(3);
//                     stopPolling();
//                 }
//             }
//         }
//     }, [inProgressFiles, startProcess, processedFiles.length, stopPolling]);

//     const handleStartProcess = async (data) => {
//         setStartProcess(true);
//         setActiveTab(1);

//         let apiKey = null;
//         let params = {};
        
//         try {
//             const projectResponse = await axios.post(
//                 `${PROJECT_URL}/projects/list`,
//                 {
//                     userInfo: {
//                         _id: sessionStorage.getItem("userid"),
//                         clientId: sessionStorage.getItem('client'),
//                         role: sessionStorage.getItem('role')
//                     },
//                     payload: {}
//                 },
//                 {
//                     headers: {
//                         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//                     }
//                 }
//             );
            
//             const currentProject = projectResponse.data.find(
//                 p => p.project_code === sessionStorage.getItem("projectCode")
//             );
            
//             if (currentProject) {
//                 if (currentProject.azure_enabled && currentProject.azure_param) {
//                     apiKey = currentProject.gpt_key;
//                     params = {
//                         service: 'azure',
//                         azure_key: currentProject.azure_param.azure_key,
//                         azure_endpoint: currentProject.azure_param.azure_endpoint
//                     };
//                 } else {
//                     apiKey = currentProject.gpt_key;
//                     params = {
//                         service: 'openai'
//                     };
//                 }
//             }
//         } catch (error) {
//             console.error("Failed to fetch project:", error);
//         }

//         const modelProvider = params.service || "openai";

//         if (!apiKey || apiKey.trim() === "") {
//             apiKey = sessionStorage.getItem("api_key") || localStorage.getItem("api_key");
//         }

//         if (!apiKey || apiKey.trim() === "") {
//             setMsg("API key not configured. Please add an API key in Project Setup.");
//             setIsSuccess(false);
//             openPopup();
//             setStartProcess(false);
//             return;
//         }

//         const currentLogs = [];
//         const updatedProcessedFiles = [];
//         const updatedUnprocessedFiles = [];

//         const formattedStartDateTime = () => {
//             const date = new Date();
//             const formattedDateString = date
//                 .toLocaleString("en-US", {
//                     day: "2-digit",
//                     month: "2-digit",
//                     year: "numeric",
//                     hour: "2-digit",
//                     minute: "2-digit",
//                     second: "2-digit",
//                     hour12: false,
//                 })
//                 .replace(/\//g, "/")
//                 .replace(",", " ");
//             const [month, day, yearAndTime] = formattedDateString.split("/");
//             return `${day}-${month}-${yearAndTime}`;
//         };

//         for (let i = 0; i < data.length; i++) {
//             let startdt = formattedStartDateTime();
//             let file = data[i];
            
//             try {
//                 if (!file.file_code) {
//                     throw new Error("File code is missing");
//                 }

//                 const payload = {
//                     project_code: sessionStorage.getItem("projectCode"),
//                     file_code: file.file_code,
//                     api_key: apiKey,
//                     process_as_wav: 0,
//                     enable_fixes: 1,
//                     pii_masking: 0,
//                     ...(modelProvider === "azure" && {
//                         azure_key: params.azure_key,
//                         azure_endpoint: params.azure_endpoint
//                     })
//                 };

//                 const response = await axios.post(
//                     `${TRANSCRIPT_URL}/diarization/`,
//                     payload,
//                     {
//                         headers: {
//                             Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//                             "Content-Type": "application/json"
//                         },
//                     }
//                 );

//                 if (response.data.status === "diarization_started" || response.data.status === "transcription_started") {
//                     const submittedFile = {
//                         ...file,
//                         file_code: file.file_code,
//                         status: "submitted",
//                         response: {
//                             message: response.data.message,
//                             submitted_at: new Date().toISOString()
//                         },
//                         start_date_time: startdt,
//                         last_modified: "",
//                     };
                    
//                     currentLogs.push({
//                         creation_date: new Date(),
//                         filename: file.name,
//                         status: "submitted",
//                         message: response.data.message
//                     });
                    
//                     updatedProcessedFiles.push(submittedFile);
//                     setInProgressFiles(prev => [...prev, submittedFile]);
//                 } else {
//                     console.error('Unexpected response status:', response.data.status);
//                     const errordate = new Date();
//                     currentLogs.push({
//                         creation_date: errordate,
//                         filename: file.name,
//                         status: "error"
//                     });
//                     updatedUnprocessedFiles.push(file);
//                 }
//             } catch (error) {
//                 console.error('Diarization Error:', error);
                
//                 const errordate = new Date();
//                 let errorMessage = error.response?.data?.detail || 
//                                 error.response?.data?.message || 
//                                 error.message ||
//                                 "An error occurred during diarization";
                
//                 currentLogs.push({
//                     filename: file.name,
//                     creation_date: errordate,
//                     error: errorMessage
//                 });
                
//                 setMsg(errorMessage);
//                 setIsSuccess(false);
//                 if (data.length === 1) {
//                     openPopup();
//                 }
                
//                 updatedUnprocessedFiles.push(file);
//             }
//         }

//         setLogsData(currentLogs);
//         setProcessedFiles(updatedProcessedFiles);
//         setUnProcessedFiles(updatedUnprocessedFiles);
//         // setStartProcess(false);
        
//         await fetchAllFiles();
        
//         if (updatedProcessedFiles.length > 0) {
//             startPolling();
//         }
//     };

//     const ReloadData = useCallback(async () => {
//         setRowSelection({});
//         setStartIndex(undefined);
//         setEndIndex(undefined);
        
//         await Promise.all([
//             fetchAllFiles(),
//             fetchInProgressDiarizations()
//         ]);
//     }, [fetchAllFiles, fetchInProgressDiarizations]);

//     const fetchBatchAudioData = async (batch_no) => {
//         await fetchAllFiles(batch_no);
//     };

//     const tabs = [
//         {
//             id: 1,
//             title: "Audio Files",
//             content: (
//                 <AudioFilesToDiarize
//                     serverStatus={serverStatus}
//                     ReloadData={ReloadData}
//                     items={fetchedFilesData}
//                     startProcess={startProcess}
//                     setFilesData={handleStartProcess}
//                     Loader={Loader}
//                     setProcessOption={() => {}}
//                     startIndex={startIndex}
//                     endIndex={endIndex}
//                     setStartIndex={setStartIndex}
//                     setEndIndex={setEndIndex}
//                     rowSelection={rowSelection}
//                     setRowSelection={setRowSelection}
//                     // diarizationSettings={diarizationSettings}
//                     // setDiarizationSettings={setDiarizationSettings}
//                 />
//             ),
//         },
//         {
//             id: 2,
//             title: "Diarization Process",
//             content: (
//                 <DiarizationProcess
//                     startProcess={startProcess}
//                     selectedFilesToProcess={inProgressFiles}
//                 />
//             ),
//         },
//         {
//             id: 3,
//             title: "Logs",
//             content: (
//                 <DiarizationProcessLogs
//                     logs={logsData}
//                     processedfiles={processedFiles}
//                     unprocessedfiles={unprocessedFiles}
//                 />
//             ),
//         },
//         {
//             id: 4,
//             title: "All Files Status",
//             content: (
//                 <DiarizationFilewiseStatusLogs 
//                     startIndex={fslstartIndex}
//                     endIndex={fslendIndex}
//                     setStartIndex={setfslStartIndex}
//                     setEndIndex={setfslEndIndex}
//                     rowSelection={fslrowSelection}
//                     setRowSelection={setfslRowSelection}
//                 />
//             ),
//         },
//     ];

//     return (
//         <>
//             <Popup
//                 isOpen={isOpenPopup}
//                 msg={msg}
//                 closeModal={closePopup}
//                 isSuccess={isSuccess}
//             />
//             <ProcessLayout
//                 startProcess={startProcess}
//                 tabs={tabs}
//                 server="Diarization Service"
//                 serverStatus={serverStatus}
//                 serviceUrl={serviceUrl}
//                 serverLoadState={serverLoadState}
//                 batching={true}
//                 handleBatchChange={fetchBatchAudioData}
//                 activeTab={activeTab}
//                 setActiveTab={setActiveTab}
//             />
//         </>
//     );
// }

import React, { useCallback, useEffect, useState, useRef } from "react";
import ProcessLayout from "../Common/ProcessLayout";
import AudioFilesToDiarize from "./DiarizationComponents/AudioFilesToDiarize";
import DiarizationProcess from "./DiarizationComponents/DiarizationProcess";
import DiarizationProcessLogs from "./DiarizationComponents/DiarizationProcessLogs";
import DiarizationFilewiseStatusLogs from "./DiarizationComponents/DiarizationFilewiseStatusLogs";
import { TRANSCRIPT_URL, PROJECT_URL } from "../../imports";
import axios from "axios";
import Popup from "../Common/Popup";
import { handleApiError } from "../Common/APIUtils";

function Diarization() {
    const [startProcess, setStartProcess] = useState(false);
    const [fetchedFilesData, setFetchedFilesData] = useState([]);
    const [inProgressFiles, setInProgressFiles] = useState([]);
    const [logsData, setLogsData] = useState([]);
    const [processedFiles, setProcessedFiles] = useState([]);
    const [unprocessedFiles, setUnProcessedFiles] = useState([]);
    const [Loader, setLoader] = useState(true);
    
    const [startIndex, setStartIndex] = useState(undefined);
    const [endIndex, setEndIndex] = useState(undefined);
    const [rowSelection, setRowSelection] = useState({});
    
    const [fslstartIndex, setfslStartIndex] = useState(undefined);
    const [fslendIndex, setfslEndIndex] = useState(undefined);
    const [fslrowSelection, setfslRowSelection] = useState({});
    const [serverStatus, setServerStatus] = useState(false);
    const [serviceUrl, setServiceUrl] = useState("");
    const [serverLoadState, setServerLoadState] = useState(true);
    const [activeTab, setActiveTab] = useState(0);
    
    let [isOpenPopup, setIsOpenPopup] = useState(false);
    let [msg, setMsg] = useState(false);
    let [isSuccess, setIsSuccess] = useState(false);

    const pollingIntervalRef = useRef(null);

    function closePopup() {
        setIsOpenPopup(false);
    }

    const openPopup = useCallback(() => {
        setIsOpenPopup(true);
    }, []);

    const stopPolling = useCallback(() => {
        if (pollingIntervalRef.current) {
            clearInterval(pollingIntervalRef.current);
            pollingIntervalRef.current = null;
        }
    }, []);

    // const fetchInProgressDiarizations = useCallback(async () => {
    //     try {
    //         const projectCode = sessionStorage.getItem("projectCode");
    //         if (!projectCode) return;

    //         const response = await axios.get(
    //             `${TRANSCRIPT_URL}/diarization/in-progress/${projectCode}`,
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                 },
    //             }
    //         );

    //         if (response.data && response.data.data) {
    //             setInProgressFiles(response.data.data);
                
    //             if (response.data.data.length === 0 && !startProcess) {
    //                 stopPolling();
    //             }
    //         }
    //     } catch (error) {
    //         console.log("No in-progress diarizations:", error.message);
    //         setInProgressFiles([]);
    //     }
    // }, [stopPolling, startProcess]);
    const submittedFilesRef = useRef([]);

    
    // const fetchInProgressDiarizations = useCallback(async () => {
    //     try {
    //         const projectCode = sessionStorage.getItem("projectCode");
    //         if (!projectCode || submittedFilesRef.current.length === 0) return;

    //         const updatedFiles = await Promise.all(
    //             submittedFilesRef.current.map(async (file) => {
    //                 try {
    //                     const statusResponse = await axios.get(
    //                         `${TRANSCRIPT_URL}/diarization/status/${projectCode}/${file.file_code}`,
    //                         {
    //                             headers: {
    //                                 Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                             },
    //                         }
    //                     );

    //                     if (statusResponse.data.status === "completed") {
    //                         return { ...file, status: "success" };
    //                     } else if (statusResponse.data.status === "failed") {
    //                         return { ...file, status: "error" };
    //                     }
    //                     return { ...file, status: "Inprogress" };
    //                 } catch (error) {
    //                     return file;
    //                 }
    //             })
    //         );

    //         setInProgressFiles(updatedFiles);
            
    //         const allDone = updatedFiles.every(f => f.status === "success" || f.status === "error");
    //         if (allDone && updatedFiles.length > 0) {
    //             stopPolling();
    //             setStartProcess(false);
    //             setActiveTab(3);
    //         }
    //     } catch (error) {
    //         console.log("Error:", error.message);
    //     }
    // }, [stopPolling]);

    // const startPolling = useCallback(() => {
    //     if (pollingIntervalRef.current) return;
    //     pollingIntervalRef.current = setInterval(() => {
    //         fetchInProgressDiarizations();
    //     }, 5000);
    // }, [fetchInProgressDiarizations]);


    const fetchAllFiles = useCallback(async (batch_no = null) => {
        try {
            setLoader(true);
            const projectCode = sessionStorage.getItem("projectCode");
            
            const response = await axios.get(
                `${TRANSCRIPT_URL}/diarization/getfilelist/${projectCode}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                    params: {
                        batch: batch_no || sessionStorage.getItem("batch") || null,
                    },
                }
            );

            const statusResponse = await axios.get(
                `${TRANSCRIPT_URL}/diarization/filewisestatusrpt/${projectCode}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                }
            );

            if (response.data && response.data.data) {
                const allFiles = response.data.data;
                const completedFileCodes = statusResponse.data.data
                    .filter(f => f.status === "Success" || f.status === "success")
                    .map(f => f.file_code);

                const availableFiles = allFiles.filter(file => {
                    const fileName = file.file_name || file.name || "";
                    const isTextFile = fileName.endsWith('.txt') || fileName.endsWith('.json') || fileName.endsWith('.csv');
                    // const isProcessing = file.status === "Inprogress" || file.status === "submitted" || file.status === "Processing" || file.status === "Success" || file.status === "success";
                    const isCompleted = completedFileCodes.includes(file.file_code);
                    
                    // return !isTextFile && !isProcessing && !isCompleted;
                    return !isTextFile && !isCompleted;
                });
                setFetchedFilesData(availableFiles);
            }
        } catch (error) {
            const errorMessage = handleApiError(error);
            setMsg(errorMessage);
            setIsSuccess(false);
            openPopup();
        } finally {
            setTimeout(() => setLoader(false), 100);
        }
    }, [openPopup]);

    // const startPolling = useCallback(() => {
    //     if (pollingIntervalRef.current) return;

    //     pollingIntervalRef.current = setInterval(() => {
    //         fetchInProgressDiarizations();
    //     }, 5000);
    // }, [fetchInProgressDiarizations]);

    useEffect(() => {
        const initializeData = async () => {
            await Promise.all([
                fetchAllFiles(),
                // fetchInProgressDiarizations(),
            ]);
            try {
                const response = await axios.get(
                    `${TRANSCRIPT_URL}/diarization/instancemonitor`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                        params: { server_instance: "GPU" },
                    }
                );
                if (response.data) {
                    setServerStatus(response.data.data[0].serverStatus);
                    setServiceUrl(response.data.data[0].service_url);
                }
            } catch (error) {
                setServerStatus(false);
                setServiceUrl("");
            } finally {
                setServerLoadState(false);
            }
        };

        initializeData();

        const checkAndStartPolling = async () => {
            const projectCode = sessionStorage.getItem("projectCode");
            if (!projectCode) return;

            try {
                const response = await axios.get(
                    `${TRANSCRIPT_URL}/diarization/in-progress/${projectCode}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    }
                );

                // if (response.data && response.data.data && response.data.data.length > 0) {
                //     startPolling();
                // }
            } catch (error) {
                console.log("No initial polling needed");
            }
        };

        checkAndStartPolling();

        return () => {
            stopPolling();
        };
    // }, [fetchAllFiles, fetchInProgressDiarizations, stopPolling]);
    }, [fetchAllFiles, stopPolling]);

    // ✅ Callback from DiarizationProcess when all files complete
    // const handleProcessingComplete = useCallback(() => {
    //     console.log("✅ All files processing complete!");
    //     setStartProcess(false);
    //     setActiveTab(3); // Move to All Files Status tab
    //     stopPolling();
    //     fetchAllFiles(); // Refresh the file list
    // }, [stopPolling, fetchAllFiles]);

    const handleProcessingComplete = useCallback(() => {
        console.log("✅ Processing complete callback received!");
        
        // Stop polling immediately
        stopPolling();
        
        // Set startProcess to false
        setStartProcess(false);
        
        // Switch to All Files Status tab
        setActiveTab(3);
        
        // Refresh data after a delay to ensure backend has updated
        setTimeout(async () => {
            console.log("🔄 Refreshing all data...");
            await fetchAllFiles();
            // await fetchInProgressDiarizations();
        }, 2000); // 2 second delay to ensure backend is updated
    // }, [stopPolling, fetchAllFiles, fetchInProgressDiarizations]);
    }, [stopPolling, fetchAllFiles]);

    // const handleStartProcess = async (data) => {
    //     setStartProcess(true);
    //     setActiveTab(1); // Move to Diarization Process tab

    //     let apiKey = null;
    //     let params = {};
        
    //     try {
    //         const projectResponse = await axios.post(
    //             `${PROJECT_URL}/projects/list`,
    //             {
    //                 userInfo: {
    //                     _id: sessionStorage.getItem("userid"),
    //                     clientId: sessionStorage.getItem('client'),
    //                     role: sessionStorage.getItem('role')
    //                 },
    //                 payload: {}
    //             },
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                 }
    //             }
    //         );
            
    //         const currentProject = projectResponse.data.find(
    //             p => p.project_code === sessionStorage.getItem("projectCode")
    //         );
            
    //         if (currentProject) {
    //             if (currentProject.azure_enabled && currentProject.azure_param) {
    //                 apiKey = currentProject.gpt_key;
    //                 params = {
    //                     service: 'azure',
    //                     azure_key: currentProject.azure_param.azure_key,
    //                     azure_endpoint: currentProject.azure_param.azure_endpoint
    //                 };
    //             } else {
    //                 apiKey = currentProject.gpt_key;
    //                 params = {
    //                     service: 'openai'
    //                 };
    //             }
    //         }
    //     } catch (error) {
    //         console.error("Failed to fetch project:", error);
    //     }

    //     const modelProvider = params.service || "openai";

    //     if (!apiKey || apiKey.trim() === "") {
    //         apiKey = sessionStorage.getItem("api_key") || localStorage.getItem("api_key");
    //     }

    //     if (!apiKey || apiKey.trim() === "") {
    //         setMsg("API key not configured. Please add an API key in Project Setup.");
    //         setIsSuccess(false);
    //         openPopup();
    //         setStartProcess(false);
    //         return;
    //     }

    //     const currentLogs = [];
    //     const updatedProcessedFiles = [];
    //     const updatedUnprocessedFiles = [];

    //     const formattedStartDateTime = () => {
    //         const date = new Date();
    //         const formattedDateString = date
    //             .toLocaleString("en-US", {
    //                 day: "2-digit",
    //                 month: "2-digit",
    //                 year: "numeric",
    //                 hour: "2-digit",
    //                 minute: "2-digit",
    //                 second: "2-digit",
    //                 hour12: false,
    //             })
    //             .replace(/\//g, "/")
    //             .replace(",", " ");
    //         const [month, day, yearAndTime] = formattedDateString.split("/");
    //         return `${day}-${month}-${yearAndTime}`;
    //     };

    //     for (let i = 0; i < data.length; i++) {
    //         let startdt = formattedStartDateTime();
    //         let file = data[i];
            
    //         try {
    //             if (!file.file_code) {
    //                 throw new Error("File code is missing");
    //             }

    //             const payload = {
    //                 project_code: sessionStorage.getItem("projectCode"),
    //                 file_code: file.file_code,
    //                 api_key: apiKey,
    //                 process_as_wav: 0,
    //                 enable_fixes: 1,
    //                 pii_masking: 0,
    //                 ...(modelProvider === "azure" && {
    //                     azure_key: params.azure_key,
    //                     azure_endpoint: params.azure_endpoint
    //                 })
    //             };

    //             const response = await axios.post(
    //                 `${TRANSCRIPT_URL}/diarization/`,
    //                 payload,
    //                 {
    //                     headers: {
    //                         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //                         "Content-Type": "application/json"
    //                     },
    //                 }
    //             );

    //             if (response.data.status === "diarization_started" || response.data.status === "transcription_started") {
    //                 const submittedFile = {
    //                     ...file,
    //                     file_code: file.file_code,
    //                     status: "submitted",
    //                     response: {
    //                         message: response.data.message,
    //                         submitted_at: new Date().toISOString()
    //                     },
    //                     start_date_time: startdt,
    //                     last_modified: "",
    //                 };
                    
    //                 currentLogs.push({
    //                     creation_date: new Date(),
    //                     filename: file.name,
    //                     status: "submitted",
    //                     message: response.data.message
    //                 });
                    
    //                 updatedProcessedFiles.push(submittedFile);
    //                 setInProgressFiles(prev => [...prev, submittedFile]);
    //             } else {
    //                 console.error('Unexpected response status:', response.data.status);
    //                 const errordate = new Date();
    //                 currentLogs.push({
    //                     creation_date: errordate,
    //                     filename: file.name,
    //                     status: "error"
    //                 });
    //                 updatedUnprocessedFiles.push(file);
    //             }
    //         } catch (error) {
    //             console.error('Diarization Error:', error);
                
    //             const errordate = new Date();
    //             let errorMessage = error.response?.data?.detail || 
    //                             error.response?.data?.message || 
    //                             error.message ||
    //                             "An error occurred during diarization";
                
    //             currentLogs.push({
    //                 filename: file.name,
    //                 creation_date: errordate,
    //                 error: errorMessage
    //             });
                
    //             setMsg(errorMessage);
    //             setIsSuccess(false);
    //             if (data.length === 1) {
    //                 openPopup();
    //             }
                
    //             updatedUnprocessedFiles.push(file);
    //         }
    //     }

    //     setLogsData(currentLogs);
    //     setProcessedFiles(updatedProcessedFiles);
    //     setUnProcessedFiles(updatedUnprocessedFiles);
        
    //     await fetchAllFiles();
        
    //     if (updatedProcessedFiles.length > 0) {
    //         startPolling();
    //     } else {
    //         // No files were successfully submitted
    //         setStartProcess(false);
    //         setActiveTab(0);
    //     }
    // };

    const handleStartProcess = async (data) => {
        console.log("🚀 Starting diarization process for", data.length, "files");

        // ✅ CHECK IF DIARIZATION PARAMS ARE ACTIVE
        try {
            const paramsResponse = await axios.get(
                `${PROJECT_URL}/projects/params/${sessionStorage.getItem("projectCode")}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                }
            );
            
            const activeDiarizationParam = paramsResponse.data.data.find(
                param => (param.process_code === 'DIARIZATION' || param.process_code === 'Diarization') && param.status === true
            );
            
            if (!activeDiarizationParam) {
                setMsg("Diarization parameters are not configured or activated. Please set up parameters in the Params section first.");
                setIsSuccess(false);
                openPopup();
                return;
            }
        } catch (error) {
            console.error("Error checking diarization params:", error);
            setMsg("Failed to verify diarization parameters. Please try again.");
            setIsSuccess(false);
            openPopup();
            return;
        }
        
        setStartProcess(true);
        setActiveTab(1); // Move to Diarization Process tab

        let apiKey = null;
        let params = {};
        
        try {
            const projectResponse = await axios.post(
                `${PROJECT_URL}/projects/list`,
                {
                    userInfo: {
                        _id: sessionStorage.getItem("userid"),
                        clientId: sessionStorage.getItem('client'),
                        role: sessionStorage.getItem('role')
                    },
                    payload: {}
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    }
                }
            );
            
            const currentProject = projectResponse.data.find(
                p => p.project_code === sessionStorage.getItem("projectCode")
            );
            
            if (currentProject) {
                if (currentProject.azure_enabled && currentProject.azure_param) {
                    apiKey = currentProject.gpt_key;
                    params = {
                        service: 'azure',
                        azure_key: currentProject.azure_param.azure_key,
                        azure_endpoint: currentProject.azure_param.azure_endpoint
                    };
                } else {
                    apiKey = currentProject.gpt_key;
                    params = {
                        service: 'openai'
                    };
                }
            }
        } catch (error) {
            console.error("Failed to fetch project:", error);
        }

        const modelProvider = params.service || "openai";

        if (!apiKey || apiKey.trim() === "") {
            apiKey = sessionStorage.getItem("api_key") || localStorage.getItem("api_key");
        }

        if (!apiKey || apiKey.trim() === "") {
            setMsg("API key not configured. Please add an API key in Project Setup.");
            setIsSuccess(false);
            openPopup();
            setStartProcess(false);
            return;
        }

        const currentLogs = [];
        const updatedProcessedFiles = [];
        const updatedUnprocessedFiles = [];

        const formattedStartDateTime = () => {
            const date = new Date();
            const formattedDateString = date
                .toLocaleString("en-US", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: false,
                })
                .replace(/\//g, "/")
                .replace(",", " ");
            const [month, day, yearAndTime] = formattedDateString.split("/");
            return `${day}-${month}-${yearAndTime}`;
        };

        for (let i = 0; i < data.length; i++) {
            let startdt = formattedStartDateTime();
            let file = data[i];
            
            try {
                if (!file.file_code) {
                    throw new Error("File code is missing");
                }

                const payload = {
                    project_code: sessionStorage.getItem("projectCode"),
                    file_code: file.file_code,
                    api_key: apiKey,
                    process_as_wav: 0,
                    enable_fixes: 1,
                    pii_masking: 0,
                    ...(modelProvider === "azure" && {
                        azure_key: params.azure_key,
                        azure_endpoint: params.azure_endpoint
                    })
                };

                console.log("📤 Submitting file:", file.name);

                const response = await axios.post(
                    `${TRANSCRIPT_URL}/diarization/`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                            "Content-Type": "application/json"
                        },
                    }
                );

                if (response.data.status === "diarization_started" || response.data.status === "transcription_started") {
                    console.log("✅ File submitted:", file.name);

                    // const submittedFile = {
                    //     ...file,
                    //     file_code: file.file_code,
                    //     status: "submitted",
                    //     response: {
                    //         message: response.data.message,
                    //         submitted_at: new Date().toISOString()
                    //     },
                    //     start_date_time: startdt,
                    //     last_modified: "",
                    // };
                     const submittedFile = {
                        ...file,
                        file_code: file.file_code,
                        status: "Inprogress",  // ✅ Set as Inprogress instead of submitted
                        response: {
                            message: response.data.message,
                            submitted_at: new Date().toISOString()
                        },
                        start_date_time: startdt,
                        last_modified: "",
                    };
                    
                    currentLogs.push({
                        creation_date: new Date(),
                        filename: file.name,
                        status: "submitted",
                        message: response.data.message
                    });
                    
                    updatedProcessedFiles.push(submittedFile);
                    setInProgressFiles(prev => [...prev, submittedFile]);
                } else {
                    console.error('❌ Unexpected response status:', response.data.status);
                    const errordate = new Date();
                    currentLogs.push({
                        creation_date: errordate,
                        filename: file.name,
                        status: "error"
                    });
                    updatedUnprocessedFiles.push(file);
                }
            } catch (error) {
                console.error('❌ Diarization Error:', error);
                
                const errordate = new Date();
                let errorMessage = error.response?.data?.detail || 
                                error.response?.data?.message || 
                                error.message ||
                                "An error occurred during diarization";
                
                currentLogs.push({
                    filename: file.name,
                    creation_date: errordate,
                    error: errorMessage
                });
                
                setMsg(errorMessage);
                setIsSuccess(false);
                if (data.length === 1) {
                    openPopup();
                }
                
                updatedUnprocessedFiles.push(file);
            }
        }

        console.log("📊 Submission complete:", {
            processed: updatedProcessedFiles.length,
            unprocessed: updatedUnprocessedFiles.length
        });

        setLogsData(currentLogs);
        setProcessedFiles(updatedProcessedFiles);
        setUnProcessedFiles(updatedUnprocessedFiles);

        submittedFilesRef.current = updatedProcessedFiles;
        
        await fetchAllFiles();
        
        if (updatedProcessedFiles.length > 0) {
            console.log("▶️ Starting polling for", updatedProcessedFiles.length, "files");
            // startPolling();
        } else {
            // No files were successfully submitted
            console.log("⚠️ No files submitted successfully");
            setStartProcess(false);
            setActiveTab(0);
        }
    };

    const ReloadData = useCallback(async () => {
        setRowSelection({});
        setStartIndex(undefined);
        setEndIndex(undefined);
        
        await Promise.all([
            fetchAllFiles(),
            // fetchInProgressDiarizations()
        ]);
    // }, [fetchAllFiles, fetchInProgressDiarizations]);
    }, [fetchAllFiles]);

    const fetchBatchAudioData = async (batch_no) => {
        await fetchAllFiles(batch_no);
    };

    // useEffect(() => {
    //     if (startProcess && inProgressFiles.length > 0) {
    //         const allCompleted = inProgressFiles.every(file => 
    //             file.status === 'success' || file.status === 'error'
    //         );
            
    //         if (allCompleted) {
    //             console.log("✅ All diarization completed");
    //             setStartProcess(false);
    //             setActiveTab(3);
    //             stopPolling();
    //         }
    //     }
    // }, [inProgressFiles, startProcess, stopPolling]);

    // useEffect(() => {
    //     if (startProcess) {
    //         if (inProgressFiles.length === 0 && processedFiles.length > 0) {
    //             console.log("✅ All files completed (empty list)");
    //             setStartProcess(false);
    //             setActiveTab(3);  // Tab index 3 = 4th tab (All Files Status)
    //             stopPolling();
    //         } else if (inProgressFiles.length > 0) {
    //             const allCompleted = inProgressFiles.every(file => {
    //                 const status = (file.status || "").toLowerCase();
    //                 return status === 'success' || 
    //                     status === 'error' ||
    //                     status === 'failed' ||
    //                     status === 'completed';
    //             });
                
    //             console.log("📊 Completion check:", { 
    //                 total: inProgressFiles.length, 
    //                 allCompleted,
    //                 statuses: inProgressFiles.map(f => f.status)
    //             });
                
    //             if (allCompleted) {
    //                 console.log("✅ All files completed");
    //                 setStartProcess(false);
    //                 setActiveTab(3);  // Tab index 3 = 4th tab
    //                 stopPolling();
    //             }
    //         }
    //     }
    // }, [inProgressFiles, startProcess, processedFiles.length, stopPolling]);

    const tabs = [
        {
            id: 1,
            title: "Audio Files",
            content: (
                <AudioFilesToDiarize
                    serverStatus={serverStatus}
                    ReloadData={ReloadData}
                    items={fetchedFilesData}
                    startProcess={startProcess}
                    setFilesData={handleStartProcess}
                    Loader={Loader}
                    setProcessOption={() => {}}
                    startIndex={startIndex}
                    endIndex={endIndex}
                    setStartIndex={setStartIndex}
                    setEndIndex={setEndIndex}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                />
            ),
        },
        {
            id: 2,
            title: "Diarization Process",
            content: (
                <DiarizationProcess
                    startProcess={startProcess}
                    selectedFilesToProcess={inProgressFiles}
                    onProcessingComplete={handleProcessingComplete}
                />
            ),
        },
        {
            id: 3,
            title: "Logs",
            content: (
                <DiarizationProcessLogs
                    logs={logsData}
                    processedfiles={processedFiles}
                    unprocessedfiles={unprocessedFiles}
                />
            ),
        },
        {
            id: 4,
            title: "All Files Status",
            content: (
                <DiarizationFilewiseStatusLogs 
                    startIndex={fslstartIndex}
                    endIndex={fslendIndex}
                    setStartIndex={setfslStartIndex}
                    setEndIndex={setfslEndIndex}
                    rowSelection={fslrowSelection}
                    setRowSelection={setfslRowSelection}
                />
            ),
        },
    ];

    return (
        <>
            <Popup
                isOpen={isOpenPopup}
                msg={msg}
                closeModal={closePopup}
                isSuccess={isSuccess}
            />
            <ProcessLayout
                startProcess={startProcess}
                tabs={tabs}
                server="Diarization Service"
                serverStatus={serverStatus}
                serviceUrl={serviceUrl}
                serverLoadState={serverLoadState}
                batching={true}
                handleBatchChange={fetchBatchAudioData}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
            />
        </>
    );
}

export default Diarization;
